module.exports = __webpack_public_path__ + "static/media/offer-made.8d63ed22.svg";